<template>
	<v-dialog v-model="dialog" max-width="860" persistent>
    <v-card class="elevation-0 pa-3">
      <v-card-title>
        <span class="headline">Invoice driver</span>
                  <v-spacer></v-spacer>
          <v-btn v-if="!invoiceId" fab small color="primary mx-1" dark @click.native="makeInvoice">
            <v-icon>receipt</v-icon>
          </v-btn>
          <v-btn icon @click.native="print">
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn icon @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>

      </v-card-title>
      <v-divider></v-divider>

            <v-layout wrap grid-list-md id="invoice" ref="invoice" class="invoiceToPrint">
              <v-card class="invoice elevation-0" style="width:100%">
          <v-container>
                <v-card-title >

                   <m-company-address :settings="settings"></m-company-address>

                  <v-spacer></v-spacer>
                  <span v-if="invoiceId" class="grey--text ma-2 pa-1">
                    <div >Facture N°: <span class="primary--text">{{ invoiceId | zeroFill }}</span></div>
                    <div >Date: <span class="primary--text">{{ selectedItem.date | date }}</span></div>
                  </span>
                  <v-spacer></v-spacer>
                  <span >
                    <div class="headline"><span class="headline primary--text">{{ selectedItem.firstname }}</span> {{ selectedItem.lastname }}</div>
                    <div ><span class="grey--text">{{ selectedItem.address }}</span></div>
                    <div ><span class="grey--text">{{ selectedItem.zip }} {{ selectedItem.city }}</span></div>
                    <div v-if="client" class="mt-3"><span class="black--text">Client: </span> <span class="primary--text">{{ client.client_firstname }} {{ client.client_lastname }}</span></div>
                  </span>
                </v-card-title>

                <v-card-title >
                  <div class="pre-total">
                  <table>
                    <tbody>
                      <tr class="">
                        <td colspan="9">Total:</td><td class="text-right"><strong>{{ (price.total_cash + price.total_factuur) | currency }}</strong></td>
                      </tr>
                      <tr class="" v-if="price.total_cash">
                        <td colspan="9">Déjà reçu (par patient):</td><td class="text-right">- {{ price.total_cash | currency }}</td>
                      </tr>
                      <tr>
                        <td colspan="9">Commission (Help4you):</td><td class="text-right">- {{ price.commision | currency }}</td>
                      </tr>
                      <tr v-if="price.rectification">
                        <td colspan="9">Rectification:</td><td class="text-right">{{ price.rectification | currency }}</td>
                      </tr>
                      <tr class="title line">
                        <td colspan="9" class="title"><strong>Décompte</strong></td><td class="title text-right"><strong>{{ (price.total) | currency}}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </v-card-title>
          </v-container>
          <v-container>
            <div class="v-data-table v-data-table--dense theme--light">
              <div class="v-data-table__wrapper">
              <table>
                <thead>
                  <tr>
                  <th class="text-left">N°</th>
                  <th class="text-left">Date</th>
                  <th class="text-left">Client</th>
                  <th class="text-left">Type</th>
                  <th class="text-left">Tarif</th>
                  <th class="text-left">Temps acc.</th>
                  <th class="text-left">Tarif acc.</th>
                  <th class="text-left">Parking</th>
                  <th class="text-right">Total cash</th>
                  <th class="text-right">Total factuur</th>
                  <th class="text-right">Commission</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in bookings" :key="i" >
                                          <td >{{ item.id }}</td>
                                          <td >{{ item.ap_date }} {{ item.ap_time | formatTime }}</td>
                                          <td >{{ item.client_lastname }} {{ item.client_firstname }}</td>
                                          <td >{{ item.type | formatIndex(types)}}</td>
                                          <td class="no-break">{{ item.price | currency }}</td>

                                          <td >{{ item.ap_waittime}} </td>
                                          <td class="no-break">{{ item.waitprice | currency}}</td>
                                          <td class="no-break">{{ item.ticket_price | currency }}</td>
                                          <td class="text-right no-break">{{ -item.price_cash | currency }}</td>
                                          <td class="text-right no-break">{{ item.price_factuur | currency }}</td>

                                          <td class="text-right no-break">{{ item.help4you | currency }}</td>


                  </tr>
                  <tr class="big-line">
                    <td colspan="8">Sous total</td><td class="text-right no-break">{{ price.total_cash | currency }}</td><td class="text-right no-break">{{ price.total_factuur | currency }}</td><td class="text-right no-break">{{ price.commision | currency}}</td>
                  </tr>
                  <tr v-for="(item) in credits" :key="item.id">
                    <td >Rectification: {{ item.id}}</td>
                    <td >{{ item.ap_date }} {{ item.ap_time | formatTime }}</td>
                    <td >{{ item.client_lastname }} {{ item.client_firstname }}</td>
                    <td >{{ item.type | formatIndex(types)}}</td>
                    <td colspan="5"> {{ item.creditReason }}</td>
                    <td class="text-right no-break">{{ item.creditAmount | currency }}</td>
                    <td class="text-right no-break"></td>
                  </tr>
                  <tr class="big-line">
                    <td colspan="10">Total</td><td class="text-right">{{ price.total_factuur | currency}}</td>
                  </tr>
                  <tr class="">
                    <td colspan="10">Commission (Help4you)</td>
                    <td class="text-right">-{{ price.commision | currency}}</td>
                  </tr>
                  <tr class="" v-if="price.rectification !== 0">
                    <td colspan="10">Rectification</td>
                    <td class="text-right">{{ price.rectification | currency}}</td>
                  </tr>
                  <tr class="title big-line">
                    <td colspan="9" class="title"><strong>Décompte</strong></td>
                    <td colspan="2" class="title text-right"><strong>{{ price.total | currency}}</strong></td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

                <div class="tva-copy mt-4 pa-2">
                  <span v-if="invoiceId">Avec la communication: <span class="heavy primary--text">{{ invoiceId | zeroFill }}/{{ selectedItem.driverId }}</span>

                  </span>
                </div>

                <m-invoice-footer :settings="settings"></m-invoice-footer>
          </v-container>
        </v-card>

      </v-layout>



    </v-card>
	</v-dialog>
</template>
<script>

import moment from 'moment';
import WalletMixin from '@/mixins/wallet'
import PrintMixin from '@/mixins/print'
export default {
  name: 'invoice',
  props: ['dialog', 'selectedItem', 'filteredBookings', 'start', 'end'],
  mixins: [WalletMixin, PrintMixin],
  data () {
    return {
      menu_date_start: false,
      menu_date_end: false,
      dateFormatted_start: null,
      dateFormatted_end: null,
      currentMonth: moment().format('MMMM YYYY'),
      search: '',
      search_clients: '',
      pagination: {
        sortBy: 'ap_date',
        descending: true
      },
      form: {},
      modes: ['pending', 'closed', 'unfounded', 'canceled'],
      types: {
        to: 'Aller',
        back: 'Retour',
        simple: 'Simple'
      },
      items: [],
      invoiceId: null,
      invoiceDate: null,
      headers: [
        {
          text: 'N° de réservation',
          width: '10',
          value: 'id'
        },
        { text: '​Date', value: 'ap_date' },
        { text: '​Destination', value: 'destination_name' },
        { text: 'Type trajet', value: 'type' },
        { text: 'Cash', value: 'price_cash' },
        { text: 'Factuur', value: 'price_factuur' },
        { text: 'Accompagnement', value: 'ap_waittime' },
        { text: 'Tarif 2', value: 'waitprice' },
        { text: 'Total du transport' }

      ],
      bookings: [],
      invoiceDone: false
    }
  },
  methods: {
    tableFilter (items, search, filter) {
      search = search.toString().toLowerCase()
      return items.filter(row => filter(row['facture'], search));
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    onRefresh () {
      this.getData();
    },
    close () {
      this.$emit('close');
    },
    print () {
      var date = moment(this.selectedItem.date).format('MM-YYYY')
      var filename = this.selectedItem.firstname + '_' + this.selectedItem.lastname + '_' + date;
      this.printInvoice(filename);
    },
    getData (status) {
      this.$http
      .post('service/wallet/totalByDriver', {status: status || 1})
      .then(response => {
        console.log('wallet response 2', response.data);

        this.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getInvoiceId () {
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/wallet/getDriverInvoiceId', {status: status || 1})
        .then(response => {
          console.log('getDriverInvoiceId response', response.data);
          if (response.data[0].id) {
            this.invoiceId = response.data[0].id;
            resolve(this.invoiceId);
          }
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    setInvoice (data) {
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/wallet/setInvoiceDriver', data)
        .then(() => {
          resolve(this.invoiceId);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    makeInvoice () {
      var app = this;
      app.invoiceDone = true;
      this.getInvoiceId().then((id) => {
        app.selectedItem.id = id;
        app.selectedItem.date = moment().format('YYYY-MM-DD');
        var data = {
          invoice: {
            id: id,
            driverId: app.selectedItem.driverId,
            clientId: (app.client && app.client.client_id) ? app.client.client_id : null,
            date: app.selectedItem.date,
            amount: (app.price.total),
            factuur: this.factuurType || 0
          },
          bookings: app.bookings.map((booking) => { return booking.id })
        }
        console.log('getInvoiceId', data);

        this.setInvoice(data).then(() => {
          console.log('setInvoice all done');
        });
      });
    },
    getBookings () {
      var app = this;
      app.invoiceDone = false;
      app.invoiceId = this.selectedItem.id || null;
      app.bookings = this.filteredBookings;
      app.client = this.getClient(app.bookings);
      this.calcInvoiceDriver()
    },
    init (v) {
      if (v) {
        this.getBookings();
        this.getSettings();
      }
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatIndex (v, obj) {
      return obj[v];
    },
    toTime (sec) {
      var time;
      if (sec > 3600) {
        time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
      } else {
        time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
      }
      return time;
    },
    zeroFill (value) {
      var length = 6;
      var number = value;
      if (number) {
        return new Array(length - number.toString().length + 1).join('0') + number;
      }
    }
  },
  watch: {
    dialog (value) {
      this.init(value);
    }
  },
  created () {}
}
</script>
<style lang="scss">
  .no-break {
    white-space: nowrap;
  }
  .tm-toolbar {
    &.v-toolbar {
      background-color: transparent !important;
    }
  }
tr.status {
  &-1 {
    background:rgba(32, 151, 2, 0.1) !important;
  }
  &-2 {
    background:rgba(248, 1, 1, 0.1) !important;
  }
}

.invoice{
  .v-data-table table {
    border-collapse: collapse;
    tbody td:first-child, tbody td:not(:first-child),
    tbody th:first-child, tbody th:not(:first-child),
    thead td:first-child, thead td:not(:first-child),
    thead th:first-child, thead th:not(:first-child) {
        padding: 0 2px;
    }
    tbody td,
    tbody th {
        height: 40px;
    }
  }

  .v-card__title {
    padding: 16px;
    font-size: 14px;
    line-height: 1.5;
  }
  .big-line{
    border-top: 2px solid rgba(0,0,0,.5) !important;
  }
}

.pre-total {
  table {
    width: 100%;
    .line{
      border-top: 1px solid rgba(0,0,0,.5) !important;
    }
  }

  width: 100%;
  border: solid 1px grey;
  padding: 10px;

}

.tva-copy {
  width: 100%;
  .heavy{
    font-weight:600
  }
}
.tva-footer{
 width: 100%;
}

@media print {
  .v-data-table {
    td.page-break  {
      color: red;
      page-break-after: always;
      width: 100%;
    }
    tbody td:first-child,
    tbody td:not(:first-child),
    tbody th:first-child,
    tbody th:not(:first-child),
    thead td:first-child,
    thead td:not(:first-child),
    thead th:first-child,
    thead th:not(:first-child) {
      padding: 0 10px
    }
  }

}
</style>
